// extracted by mini-css-extract-plugin
export default {"tableWrap":"RelatedConsultationsPanel_tableWrap__m3e5z","table":"RelatedConsultationsPanel_table__VaB+W","emptyState":"RelatedConsultationsPanel_emptyState__67O+Z"};